import { useAuth } from '../contexts/AuthContext'
import { useCondominium } from '../contexts/CondominioContext'

/**
 * A gestora a gerir arrendamentos numa propriedade (decisão de produto de 2026-11-05): com
 * ARRENDAMENTO_READ/MANAGE/PAGAMENTO_APROVAR vê os contratos, as rendas e os recebimentos de todos os
 * proprietários; com MANAGE faz contratos em nome do proprietário; com MANAGE ou PAGAMENTO_APROVAR regista
 * e aprova os pagamentos. Num condomínio o arrendamento é só entre proprietário e inquilino — `active` é
 * sempre falso, mesmo que o papel tenha as permissões (o servidor também as ignora lá).
 */
export function useRentalManagement(): { active: boolean; canManage: boolean; canReceive: boolean } {
  const { hasAnyPermission, hasPermission } = useAuth()
  const { activeCondominium } = useCondominium()
  const ePropriedade = activeCondominium?.tipo === 'PROPERTIES'
  const active = ePropriedade && hasAnyPermission('ARRENDAMENTO_READ', 'ARRENDAMENTO_MANAGE', 'ARRENDAMENTO_PAGAMENTO_APROVAR')
  return {
    active,
    canManage: active && hasPermission('ARRENDAMENTO_MANAGE'),
    canReceive: active && hasAnyPermission('ARRENDAMENTO_MANAGE', 'ARRENDAMENTO_PAGAMENTO_APROVAR'),
  }
}
